import { QrCodeScanner as ScannerIcon } from '@mui/icons-material';
import React from 'react';

const ScanHeader: React.FC = () => {
  return (
    <div className='flex items-center justify-between mb-4'>
      <div className='flex items-center gap-3'>
        <div className='p-2.5 rounded-xl bg-[#ff7500] shadow-sm flex items-center justify-center'>
          <ScannerIcon sx={{ fontSize: 24, color: 'white', opacity: 0.9 }} />
        </div>
        <h3 className='text-xl font-black text-gray-800 leading-tight'>
          Panel de Escaneo
        </h3>
      </div>

      <div className='flex items-center gap-2'>
        <div className='w-2 h-2 rounded-full bg-green-500 animate-pulse shadow-[0_0_8px_rgba(34,197,94,0.5)]' />
        <span className='text-[11px] font-black uppercase tracking-widest text-gray-900'>
          Listo para escanear
        </span>
      </div>
    </div>
  );
};

export default ScanHeader;
